function BuyNow() {

}


BuyNow.prototype.listenBuyNowSubmitEvent = function () {
    var SubmitBtn = $('.buy-now-btn');
    SubmitBtn.click(function (event) {
        // 阻止一些默认行为，比如这个按钮是在form 表单里提交，默认情况下是会执行form表单提交的1
        event.preventDefault();
        var local_this = $(this);
        var sku_id = local_this.attr('data-sku-id');
        if(sku_id === ''){
            swal({
                title: "info", text: "Pls choose Spec for the goods", type: "info",
                showCancelButton: false, showConfirmButton: true, buttons: false, timer: 2000,
            });
            return;
        }

        var count;

        count = $('.count-show').val();
        count = parseInt(count);
        if (count < 1) {
            count = 1;
        } else if(count > 10){
             count = 10;
        }
        //  disable button 防止用户重复提交
        local_this.css("pointer-events", "none")
        local_this.text('Submitting...');

         // 把SKU ID 放入FORM表单人INPUT
        var buy_now_form =  $('.buy-now-form');
        buy_now_form.find("input[name='sku_id']").val(sku_id);
        // 注：为了方便起见，把SHOP NOW的SKU字典数据名取成和购物车的字典数据同名cart-data-in-cookie
        // 在计算运费时从cart-data-in-cookie里获取SKU对应的数量
        var cart_data_in_cookie = JSON.stringify({[sku_id]: count})
        buy_now_form.find("input[name='cart-data-in-cookie']").val(cart_data_in_cookie);
        // gain address data
        // {'pk': 1, 'country': country, 'receiver': receiver,'addr': addr, 'city':city,
        //  'state': state, 'zip_code': zip_code, 'phone': phone, 'is_default': 1};
        var address_str = $.cookie('qskyme_address');
        if(address_str){
            buy_now_form.find("input[name='address-list-str']").val(address_str);
        }

        buy_now_form.find("input[name='quantity']").val(count);
        // 提交FORM 表单
        buy_now_form.submit();

    })
}

function GetUrlRelativePath() {

　　　　var url = document.location.toString();

　　　　var arrUrl = url.split("//");

　　　　var start = arrUrl[1].indexOf("/");


       return arrUrl[1].substring(start);

　　}



BuyNow.prototype.run = function () {

    this.listenBuyNowSubmitEvent();
}

$(function () {
    var buyNow = new BuyNow();
    buyNow.run();
})

